import React, {
    PropsWithChildren,
    useCallback,
    useContext,
    useMemo,
    useState,
} from 'react';
import { ClbLinkPros } from '@celebration/design-system/dist/lib/toast-base/props.types';
import IToastContext from './interfaces/IToastContext';
import IToast from '../../../common/components/toasts/interfaces/IToast';

const ToastContext = React.createContext<IToastContext>({} as IToastContext);

function ToastProvider({ children }: Readonly<PropsWithChildren>) {
    const [toasts, setToasts] = useState<IToast[]>([]);

    const setToast = useCallback(
        (
            type: 'negative' | 'positive' | 'warning',
            title: string,
            description: string | undefined,
            link?: ClbLinkPros | undefined,
        ) => {
            setToasts([
                ...toasts,
                {
                    type,
                    title,
                    description,
                    open: true,
                    link,
                } as IToast,
            ]);
        },
        [toasts],
    );

    const provided = useMemo(() => ({ toasts, setToast }), [toasts, setToast]);

    return (
        <ToastContext.Provider value={provided}>
            {children}
        </ToastContext.Provider>
    );
}

export const useToast = (): IToastContext => useContext(ToastContext);

export default (() => {
    return {
        ToastContext,
        ToastProvider,
        useToast,
    };
})();
